module.exports = __webpack_public_path__ + "static/media/policy_documents.30cb33d3.svg";